import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries';

//dropdown EMPRESAS

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.tipoProducto} value={props.elemento._id}>{props.elemento.descrProducto}</option>

  )
};

const ListaPro = ({list, handleLista}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrProducto" id="miLista4" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};


// const AddProcEjec2 = ({this.props.styles, handleSubmit, handleChange, args, errors}) => {
  class AddItemOC2 extends React.Component{
    state={argsAdd: {}}

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    this.setState({argsAdd})
  }

  render(){
    const {argsAdd} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let args = Object.assign({}, this.props.args, argsAdd)
    args._id = this.props.idLista._id
    args.numOrdenCompra = this.props.idLista.numOrdenCompra

    // let listPro=[]
    // listPro = this.props.list.filter(elemento => elemento.tipoProducto===this.props.tipoC)
  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Item nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}>
          <div className="ui five column stackable grid">
            <div className="row container">
              <div className="column" width="60%">                
                <Form.Field>
                  <label style={this.props.styles.label}>Producto</label>
                  <ListaPro list={this.props.list} handleLista={this.props.handleLista} />
                </Form.Field>    
              </div>
              <div className="column" width="10%">
                <Form.Field>
                  <label style={this.props.styles.label}>Cantidad</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="cantidadAprob" id="cantidadAprob" placeholder='Cantidad' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" width="10%">
                <Form.Field>
                  <label style={this.props.styles.label}>Valor Und</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="valorUniAprob" id="valorUniAprob" placeholder='Valor Und' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" width="10%">
                <Form.Field>
                  <label style={this.props.styles.label}>% Descuento</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="porcDcto" id="porcDcto" placeholder='% Descuento' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" width="10%">
                <Form.Field>
                  <label style={this.props.styles.label}>% IVA</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="porcIVA" id="porcIVA" placeholder='% IVA' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
            </div>
          </div>
          <div className="row container">
            <div className="column" width="100%">                
              <Button style={this.props.styles.confirmar} type='submit' fluid>
                AGREGAR
              </Button>
            </div>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </div>
        </Form>
      </div>
    </div>
  )
  }
}

// export default AddProcEjec2
export default compose(

  )(AddItemOC2)